export function useSSR(): { isBrowser: boolean; isServer: boolean } {
  const isDOM = typeof window !== 'undefined' && window.document && window.document.documentElement;

  return {
    isBrowser: !!isDOM,
    isServer: !isDOM,
  };
}
